export default __webpack_public_path__ + "static/media/twitter_icon.18716d32.svg";